module.exports = __webpack_public_path__ + "static/media/ectpl_logo_new.eb8a24e0.png";